@if (entry.meetingType) {
  <p-tag [value]="entry.meetingType" severity="info"></p-tag>
}

@if (isMissingTeamsLink(entry)) {
  <p-tag
    severity="warning"
    value="Noch kein Link"
    [pTooltip]="missingTeamsLinkHint"
    tooltipPosition="bottom"
  ></p-tag>
} @else if (canEditTeamsMeeting(entry)) {
  <app-meeting-link-docent-actions
    [meetingData]="toMeetingLinkData(entry)"
    [lecturerUsers]="lecturerUsers"
    (meetingChanged)="meetingChanged.emit()"
  ></app-meeting-link-docent-actions>
} @else if (entry.meetingLink) {
  <app-meeting-link-readonly-actions
    [meetingData]="entry"
    [label]="label"
  ></app-meeting-link-readonly-actions>
} @else if (!entry.meetingType) {
  <p-tag severity="secondary" value="Präsenz"></p-tag>
} @else {
  <span class="muted">—</span>
}
